import React from "react";

import styles from "styles/misc.module.css";

export default function ErrorTag({ message }) {
	return <p className={styles.error}>{message}</p>;
}
